/**
 * Path prefixes that are mounted OUTSIDE the authenticated app shell.
 *
 * Hits to these URLs must reach their dedicated `<Route>` directly, without
 * triggering MSAL's interactive sign-in, the role-based router, or any of the
 * data-fetching effects that assume an authenticated session.
 *
 * Keep this list short — every entry is a privilege escalation surface and
 * shouldn't be added without a deliberate design decision.
 */
export const PUBLIC_ROUTE_PREFIXES: readonly string[] = [
	"/p/talents/" // Anonymized talent fiche reached via token URL
];

/**
 * Returns true when the given pathname is rooted in one of the public-only
 * prefixes — used in <c>app.tsx</c> to bypass the auth gate.
 */
export const isPublicRoute = (pathname: string): boolean =>
	PUBLIC_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix));
